
const configBase = {
  //api: "http://localhost:3002/api/",
  //front: "http://localhost:3000/",
  api: "https://odontobase.intelite.com.br/api/",
  front: "https://odontobase.intelite.com.br/", 

  empresaMaiuscula: 'ODONTOBASE',
  empresaMiniscula: 'Odontobase',
  corPrincipal: '#3fbc96',
  corSecundaria: '#fff',
  // Margem reservada (Antes do formulário PF)
  margemReservada: false,
  margemReservadaMsg: "",

  // Usar ou não o Módulo de Dependentes
  moduloDependentes: true,
  corDependentes: '#fff',
  bgDependentes: '#fb8c00',
  statusDependentes: 'DEPENDENTES',
  // Fim Módulo de Dependentes

  // Usar ou não o Módulo de Func de Empresa
  moduloFuncEmpresa: false,
  bgFuncEmpresa: '#1b5e20',
  corFuncEmpresa: '#fff',
  statusFuncEmpresa: 'FUNC DE EMPRESA',
  statusMinFuncEmpresa: 'Func de Empresa',
  // Fim Módulo de Func de Empresa

  // Usar ou não o Cupon de Desconto
  moduloCupomDesconto: true,
  // Fim Cupon de Desconto

  // Cores dos status
  bgIndeferida: '#b87547',
  corIndeferida: '#fff',
  bgPendente: '#afb42b',
  corPendente: '#fff',
  bgEmAverbacao: '#ab47bc',
  corEmAverbacao: '#fff',
  bgEmAnalise: '#9e9e9e',
  corEmAnalise: '#fff',
  bgCanceladas: '#b71c1c',
  corCanceladas: '#fff',
  bgImplementadas: '#01579b',
  corImplementadas: '#fff',
  bgPreImplantadas: '#2196f3',
  corPreImplantadas: '#fff',
  bgNova: '#66bb6a',
  corNova: '#fff',
  bgValidadas: '#67a3ef',
  corValidadas: '#fff',

  // Satus nomes
  statusIndeferida: 'INDEFERIDA',
  statusPendente: 'PAG PENDENTE',
  statusEmAverbacao: 'EM AVERBAÇÃO',
  statusEmAnalise: 'EM ANÁLISE',
  statusCanceladas: 'CANCELADA',
  statusImplementadas: 'IMPLANTADA',
  statusPreImplantadas: 'PRÉ-IMPLANTADA',
  statusNova: 'NOVA',
  statusNovas: 'VALIDADAS',
  statusValidada: 'NOVA',
  statusValidadas: 'VALIDADAS',
  // Satus minúsculas nomes
  statusMinIndeferida: 'Indeferidas',
  statusMinPendente: 'Pag Pendente',
  statusMinEmAverbacao: 'Em Averbação',
  statusMinEmAnalise: 'Em Análise',
  statusMinCanceladas: 'Canceladas',
  statusMinImplementadas: 'Implantadas',
  statusMinPreImplantadas: 'Pré-Implantadas',
  statusMinNova: 'Novas',
  statusMinValidadas: 'Validadas',

  // Satus nomes PJ
  statusPendentePJ: 'PAG PENDENTE PJ',
  statusConfPendentePJ: 'CONFIRMAÇÃO PENDENTE PJ',
  statusEmProcessamentoPJ: 'EM PROCESSAMENTO PJ',
  statusEmAnalisePJ: 'EM ANÁLISE PJ',
  statusIndeferidaPJ: 'INDEFERIDA PJ',
  statusCanceladasPJ: 'CANCELADA PJ',
  statusImplementadasPJ: 'IMPLANTADA PJ',
  // Satus minúsculas nomes PJ
  statusMinIndeferidaPJ: 'Indeferidas PJ',
  statusMinConfIndeferidaPJ: 'Confirmação Pendente PJ',
  statusMinPendentePJ: 'Pag Pendente PJ',
  statusMinEmAnalisePJ: 'Em Análise PJ',
  statusMinCanceladasPJ: 'Canceladas PJ',
  statusMinImplementadasPJ: 'Implantadas PJ',

  // Cores dos status PJ
  bgIndeferidaPJ: '#b87547',
  corIndeferidaPJ: '#fff',
  bgConfPendentePJ: '#66bb6a',
  corConfPendentePJ: '#fff',
  bgEmProcessamentoPJ: '#795548',
  corEmProcessamentoPJ: '#fff',
  bgPendentePJ: '#afb42b',
  corPendentePJ: '#fff',
  bgEmAnalisePJ: '#9e9e9e',
  corEmAnalisePJ: '#fff',
  bgCanceladasPJ: '#b71c1c',
  corCanceladasPJ: '#fff',
  bgImplementadasPJ: '#4792b8',
  corImplementadasPJ: '#fff',
};

export default configBase;